export function RowDivider() {
  return <div className="h-[1px] bg-neutrals-N200 col-span-full" />;
}
